"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Dropdown = _interopRequireDefault(require("react-bootstrap/Dropdown"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * A Toggle that controls the appearance of the dropdown menu.
 */
const DropdownToggle = props => {
  const {
    label,
    onClear,
    selected,
    type,
    ...rest
  } = props;
  const toggleLabel = typeof label === 'function' ? label() : label;
  const toggleType = type || 'submit';
  const classList = [''];
  if (selected) classList.push('selected');
  const classes = classList.join(' ');
  const clearHandler = e => {
    e.stopPropagation();
    if (onClear) onClear(e);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Dropdown.default.Toggle, _extends({
    className: classes,
    variant: "",
    type: toggleType
  }, rest), toggleLabel), selected && /*#__PURE__*/_react.default.createElement("button", {
    "aria-label": "Clear",
    className: "clear",
    onClick: clearHandler,
    type: "button"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, "Clear")));
};
DropdownToggle.propTypes = {
  /** The HTML identifier for the toggle button. */
  id: _propTypes.default.string.isRequired,
  /** The label of the dropdown, either a string generator function or static string. */
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
  /** An event handler/listener for the "clear" event. */
  onClear: _propTypes.default.func,
  /** A flag, indicating if anything in this Dropdown is selected. */
  selected: _propTypes.default.bool,
  /** The type of the HTML <button> rendered. */
  type: _propTypes.default.string
};
DropdownToggle.defaultProps = {
  label: 'Select One',
  selected: false
};
var _default = exports.default = DropdownToggle;